import { Controller } from "react-hook-form";
import { NoxusFormLabel } from "./NoxusFormLabel";
import { Slider } from "../shadcn/slider";
import { cn } from "@/lib/utils";

interface IEnumSlider {
  value: string;
  values: string[];
  onChange: (v: string) => void;
  tooltip?: string;
  label: string;
  description?: string;
  isDisabled?: boolean;
  isHorizontal?: boolean;
  name?: string;
}

interface IEnumSliderField {
  name: string;
  values: string[];
  defaultValue?: string;
  tooltip?: string;
  label: string;
  description?: string;
  control?: any;
  isDisabled?: boolean;
  isHorizontal?: boolean;
}

export const EnumSliderField = ({
  name,
  label,
  values,
  defaultValue,
  tooltip,
  description,
  control,
  isDisabled,
  isHorizontal,
}: IEnumSliderField) => {
  return (
    <Controller
      defaultValue={defaultValue || values[0]}
      control={control}
      disabled={isDisabled}
      render={({ field }) => (
        <EnumSlider
          label={label}
          onChange={field.onChange}
          value={field.value}
          values={values}
          tooltip={tooltip}
          description={description}
          isDisabled={isDisabled}
          isHorizontal={isHorizontal}
          name={name}
        />
      )}
      name={name}
    />
  );
};

const EnumSlider = ({
  value,
  values,
  tooltip,
  label,
  description,
  onChange,
  isDisabled,
  isHorizontal,
  name,
}: IEnumSlider) => {
  const currentIndex = values.indexOf(value);

  const handleChange = (index: number) => {
    onChange(values[index]);
  };

  return (
    <div
      className={`w-full flex ${
        isHorizontal ? "flex-row items-center gap-4" : "flex-col"
      }`}
    >
      <div className="flex-1">
        {label && (
          <NoxusFormLabel label={label} tooltip={tooltip} name={name} />
        )}
        {description && (
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        )}
      </div>

      <div className="relative flex flex-col mx-4 flex-1">
        <Slider
          value={[currentIndex]}
          onValueChange={(index) => handleChange(index[0])}
          max={values.length - 1}
          min={0}
          step={1}
          disabled={isDisabled}
          className="w-full"
        />

        {/* Labels container */}
        <div className="w-full h-6 relative mt-2">
          {values.map((val, index) => (
            <span
              key={val}
              className={cn(
                `absolute text-xs cursor-pointer capitalize transform -translate-x-1/2 text-muted-foreground`,
                val === value && "text-foreground",
                isDisabled && "cursor-not-allowed"
              )}
              style={{
                left:
                  index === 0
                    ? "0.5rem"
                    : index === values.length - 1
                      ? `calc(${(index / (values.length - 1)) * 100}% - 0.5rem)`
                      : `${(index / (values.length - 1)) * 100}%`,
              }}
              onClick={() => !isDisabled && handleChange(index)}
            >
              {val}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
